import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '../AppContext';

const SupportedLanguageMap = {
	en: 'English',
	fr: 'Français',
};

const LanguageSelector = () => {
	const app = React.useContext(AppContext);
	const { i18n } = useTranslation();
	const currentLanguage = i18n.resolvedLanguage; //this will be the resolved resource language used, for now, either "en" or "es" instead of "en-US" or "es-MX" or whatever

	React.useEffect(() => {
		if (app.userdata.language !== currentLanguage) {
			app.setLanguage(currentLanguage);
		}
	}, [app, currentLanguage]);

	const handleOnLanguageSelection = React.useCallback((e) => {
		const newLanguage = e?.target?.value;
		e?.target?.blur?.();

		if (typeof SupportedLanguageMap[newLanguage] !== 'undefined') {
			i18n.changeLanguage(newLanguage);
		}
	}, [i18n]);

	const languageEntries = React.useMemo(() => {
		const result = [];

		for (const [language, humanName] of Object.entries(SupportedLanguageMap)) {
			result.push(
				<option key={language} value={language}>{humanName}</option>,
			);
		}

		return result;
	}, []);

	if (languageEntries.length < 2) {
		return null;
	}

	return (
		<select onChange={handleOnLanguageSelection} defaultValue={currentLanguage}>
			{languageEntries}
		</select>
	);
};

export default React.memo(LanguageSelector);
